import { useState } from "react";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import Modal from "react-bootstrap/Modal";
import { Button } from "react-bootstrap";
import { deleteEegSegment } from "../../actions/patientActions";

const DeleteSegmentConfirmModal = ({
  show,
  handleClose,
  token,
  segment,
  onDeleted,
}) => {
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();

  const handleConfirm = () => {
    if (!segment?.id) {
      toast.error("Segment not found");
      return;
    }
    setLoading(true);
    dispatch(deleteEegSegment(token, segment.id))
      .then(() => {
        onDeleted?.();
        setLoading(false);
        handleClose();
      })
      .catch(() => {
        setLoading(false);
      });
  };

  const rangeText =
    segment != null
      ? `${Number(segment.start_segment).toFixed(2)}s – ${Number(segment.end_segment).toFixed(2)}s`
      : "";

  return (
    <Modal
      show={show}
      onHide={handleClose}
      animation={false}
      aria-labelledby="delete-segment-modal-title"
      centered
    >
      <Modal.Header closeButton className="modal-header">
        <Modal.Title id="delete-segment-modal-title">
          Delete EEG Segment
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        Are you sure you want to delete this segment ({rangeText})? This cannot
        be undone.
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose} disabled={loading}>
          Cancel
        </Button>
        <Button variant="danger" onClick={handleConfirm} disabled={loading}>
          {loading ? "Deleting..." : "Delete"}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default DeleteSegmentConfirmModal;
